const toDecimalFormat = (string: any) => parseFloat(string || '0').toLocaleString('th-TH', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '3rem',
      class: 'text-center',
    },
    name: {
      name: 'ชื่อสิินค้า',
      width: '1fr',
    },
    count: {
      name: 'จำนวน',
      width: '4rem',
      class: 'text-right',
      filter: (val: string) => toDecimalFormat(val),
    },
    newCount: {
      name: 'จำนวนที่แบ่ง',
      width: '8rem',
      class: 'text-right',
    },
    unit: {
      name: '',
      width: '4rem',
    },
    totalWeight: {
      name: 'น้ำหนัก',
      width: '4rem',
      filter: (val: string) => toDecimalFormat(val),
      class: {
        text: 'text-right',
        cell: 'text-center',
      },
    },
  },
};
